import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import dateformat from 'dateformat';
import _ from 'lodash';

import { Row, Col, OverlayTrigger, Image, Tooltip } from 'react-bootstrap';
import { AreaChart, Area, XAxis, } from 'recharts';
import Measure from 'react-measure';

import styles from './styles.module.scss';
import { localizedStrings } from 'src/localization/index.jsx';

class VideoAnalyticsRowView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      segments: [],
      chart: {
        width: 250,
        visible: false
      }
    }
    this.formatTimeSpent = this.formatTimeSpent.bind(this);
    this._handleMouseOut = this._handleMouseOut.bind(this);
    
    // localized contents
    this.localizedCommons = localizedStrings.commons;
  }

  componentDidMount() {
    var analytics = this.props.analytics;
    if (analytics && analytics.dataPoints) {
      var processedData = this.processAnalytics(analytics);

      this.setState({
        ...processedData
      })
    }
  }

  processAnalytics(analytics) {
    if (!analytics || analytics.dataPoints.length == 0) {
      return [];
    }

    var segmentLength = _.get(this.props, "asset.metadata.video_segment_length") || 5;
    var totalDuration = _.get(this.props, "asset.metadata.video_duration") || 0;

    if (totalDuration == 0) {
      var lastSegment = analytics.dataPoints[analytics.dataPoints.length - 1];
      totalDuration = lastSegment.index + segmentLength;
    }

    var segmentCounts = Math.ceil(totalDuration / segmentLength);
    segmentCounts = Math.max(segmentCounts, analytics.dataPoints.length);

    var segments = []
    for (var i = 0; i < segmentCounts; i++) {
      var segment = {
        index: i * segmentLength,
        totalTimeSpent: 0.0,
        count: 0
      }

      segments.push(segment);
    }

    analytics.dataPoints.forEach((element) => {
      var index = segments.findIndex(item => {
        return item.index == element.index;
      });

      if (index != -1) {
        segments[index] = element;
      }

    })

    return {
      segments: segments,
      segmentLength: segmentLength,
      duration: totalDuration
    }
  }

  render() {
    if (this.state.segments.length == 0 || this.props.analytics.type != 'VIDEO_ANALYTICS') {
      return null;
    }

    let activeSegment = this.state.activeSegment || {
      index: 0,
      totalTimeSpent: 0,
      count: 0
    };

    let timeSpent = activeSegment.index;
    let views = this.padNumber(activeSegment.count, 2);

    return (
      <div className={styles.contactPageMetrics}>
        <Col md={12} className={cx(styles.noWrap,styles.noPadding)}>
          {this.renderVideoSegmentAnalytics()}
        </Col>
        <Col md={12} className={styles.noPadding}>
          {this.props.lastViewedDate &&
            <h5 className={styles.lastViewed}>{this.localizedCommons.last_viewed} {dateformat(this.props.lastViewedDate, 'dd mmm yyyy')}</h5>
          }
        </Col>
      </div>
      
    );
  }

  renderVideoSegmentAnalytics() {

    return (
      <Measure bounds
        onResize={(contentRect) => {
          this.setState({
            chart: {
              ...this.state.chart,
              width: contentRect.bounds.width
            }
          })
        }}>

        {({ measureRef }) =>
          <div ref={measureRef} >
            <div className={styles.chart} onMouseOut={(e) => this._handleMouseOut(e)}>
              <div className={styles.segments}>
                {this.renderSegments()}
              </div>
              {this.renderCursor()}
              {this.renderTimeLine()}
            </div>
          </div>
        }
      </Measure>
    );
  }
  _handleMouseOut(e) {
    this.setState({
      activeSegment: null,
      seekTime: 0
    })
  }
  renderSegments() {
    if (!this.state.duration) {
      return false;
    }

    var width = `${(this.state.segmentLength / Math.ceil(this.state.duration)) * 100}%`;

    var segmentItems = this.state.segments.map(segment => {
      var viewClass = styles.views_0x;

      if (segment.count == 1) {
        viewClass = styles.views_1x;
      } else if (segment.count == 2) {
        viewClass = styles.views_2x;
      } else if (segment.count > 2) {
        viewClass = styles.views_3x;
      }

      return (
        <div key={segment.index}
          className={cx(styles.segment, viewClass)}
          style={{ width: width }}
          onMouseMove={(e) => this._handleMouseOver(e, segment)}>
          <div className={styles.bar}></div>
        </div>
      );
    })

    return segmentItems;
  }
  _handleMouseOver(e, segment) {
    var parent = document.querySelector(`.${styles.segments}`);
    var offsetLength = Math.max(e.target.offsetLeft + e.nativeEvent.offsetX, 0);
    var totalWidth = parent.offsetWidth;

    this.setState({
      activeSegment: segment,
      seekTime: (offsetLength / totalWidth)
    })
  }
  renderCursor() {
    if (!this.state.activeSegment) {
      return false;
    }

    var style = {
      left: `${this.state.seekTime * 100}%`
    }

    var views = 'No';

    if (this.state.activeSegment.count == 1) {
      views = '1x';
    } else if (this.state.activeSegment.count == 2) {
      views = '2x';
    } else if (this.state.activeSegment.count > 2) {
      views = '3x';
    }


    return (
      <div className={styles.cursor} style={style}>
        <div className={styles.time}>{this.formatTimeSpent(this.state.duration * this.state.seekTime)}</div>
        <div className={styles.line}></div>
        <div className={styles.views}>
          <div className={styles.value}>{views}</div>
          <div className={styles.label}>{this.localizedCommons.views}</div>
        </div>
      </div>
    )
  }

  renderTimeLine() {
    if (!this.state.duration) {
      return false;
    }

    var first = this.state.duration / 3;
    var second = this.state.duration * 2 / 3;

    return (
      <div className={styles.timeLine}>
        <div className={styles.tick}>00</div>
        <div className={styles.tick}>{this.formatTimeSpent(first)}</div>
        <div className={styles.tick}>{this.formatTimeSpent(second)}</div>
        <div className={styles.tick}>{this.formatTimeSpent(this.state.duration)}</div>
      </div>
    )
  }

  padNumber(number = 0, pad) {
    number = Math.ceil(number);

    const length = pad - String(number).length + 1;
    let padding = '';
    if (length > 0) {
      padding = Array(pad - String(number).length + 1).join('0');
    }
    return padding + number;
  }

  formatTimeSpent(timeSpent) {
    let minutes = this.padNumber(Math.floor(timeSpent / 60), 2);
    let seconds = this.padNumber(timeSpent % 60, 2);

    return `${minutes}:${seconds}`;
  }

}

export default VideoAnalyticsRowView;
